module.exports = __webpack_public_path__ + "static/media/min_dark.45faacd4.svg";